/* eslint-disable react/require-default-props */
import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/cjs/prism-light';
import oneLight from 'react-syntax-highlighter/dist/cjs/styles/prism/one-light';
import bash from 'react-syntax-highlighter/dist/cjs/languages/prism/bash';
import csharp from 'react-syntax-highlighter/dist/cjs/languages/prism/csharp';
import css from 'react-syntax-highlighter/dist/cjs/languages/prism/css';
import java from 'react-syntax-highlighter/dist/cjs/languages/prism/java';
import javascript from 'react-syntax-highlighter/dist/cjs/languages/prism/javascript';
import json from 'react-syntax-highlighter/dist/cjs/languages/prism/json';
import markup from 'react-syntax-highlighter/dist/cjs/languages/prism/markup';
import php from 'react-syntax-highlighter/dist/cjs/languages/prism/php';
import python from 'react-syntax-highlighter/dist/cjs/languages/prism/python';
import ruby from 'react-syntax-highlighter/dist/cjs/languages/prism/ruby';
import sql from 'react-syntax-highlighter/dist/cjs/languages/prism/sql';
import typescript from 'react-syntax-highlighter/dist/cjs/languages/prism/typescript';
import yaml from 'react-syntax-highlighter/dist/cjs/languages/prism/yaml';

const LANGUAGES: Record<string, any> = {
  bash,
  sh: bash,
  shell: bash,
  csharp,
  cs: csharp,
  css,
  java,
  javascript,
  js: javascript,
  jsx: javascript,
  json,
  html: markup,
  xml: markup,
  markup,
  php,
  python,
  py: python,
  ruby,
  rb: ruby,
  sql,
  typescript,
  ts: typescript,
  tsx: typescript,
  yaml,
  yml: yaml,
};

Object.keys(LANGUAGES).forEach((name) => SyntaxHighlighter.registerLanguage(name, LANGUAGES[name]));

interface MarkdownCodeProps {
  inline?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const MarkdownCode: React.FC<MarkdownCodeProps> = ({ inline, className, children }) => {
  const language = /language-(\w+)/.exec(className || '')?.[1]?.toLowerCase();
  if (inline) return <code className={className}>{children}</code>;

  return (
    <SyntaxHighlighter
      language={language && LANGUAGES[language] ? language : 'text'}
      style={oneLight}
      customStyle={{ margin: 0, borderRadius: 6, fontSize: 13 }}
      wrapLongLines
    >
      {String(children).replace(/\n$/, '')}
    </SyntaxHighlighter>
  );
};

export default MarkdownCode;
